import { DomainAPI, Channel, getHeader } from "../utils/setting";

import { checkResponse } from "../utils/checkResponse";

const serviceMenuItem = {
  state: {
    listMenu: [],
    listMenuFeatured: [],
    position: 0,
    total: 0,
    count: 0,
    totalFeatured: 0,
    allMenuItem: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    editMenuItem(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceMenuItem/editMenuItem";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getMenuItem(payload, rootState) {
      const _this = this;
      if (payload.id && !payload.id.length) {
        dispatch.serviceMenu.changeIdMenuArray([]);
      }
      let url =
        DomainAPI + Channel + "/api/secure/serviceMenuItem/getListMenuItemById";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            // dispatch.serviceMenu.changeIdMenuArray(payload.id)
            _this.setState({
              listMenu: result.data.list,
              position: result.data.maxPosition,
              total: result.data.total,
              count: result.data.count,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getMenuItemFeatured(payload, rootState) {
      const _this = this;
      // if(!payload.id || (payload.id && !payload.id.length)) payload.id = rootState.serviceMenu.idMenuArray;
      if (payload.id && !payload.id.length) {
        dispatch.serviceMenu.changeIdMenuArray([]);
        _this.setState({ listMenuFeatured: [], totalFeatured: 0 });
        return {
          code: 1,
          data: {
            list: [],
            total: 0,
            maxPosition: 0,
          },
        };
      }
      let url =
        DomainAPI + Channel + "/api/secure/serviceMenuItem/getListMenuItemById";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          filter: [{ featured: 1 }],
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              listMenuFeatured: result.data.list,
              position: result.data.maxPosition,
              totalFeatured: result.data.total,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getAllMenuItem(payload = {}, rootState) {
      const _this = this;
      // if(!payload.id || (payload.id && !payload.id.length)) payload.id = rootState.serviceMenu.idMenuArray;
      if (payload.id && !payload.id.length) {
        dispatch.serviceMenu.changeIdMenuArray([]);
        _this.setState({ listMenu: [], position: 0, total: 0 });
        return {
          code: 1,
          data: {
            list: [],
            total: 0,
            maxPosition: 0,
          },
        };
      }
      let url = DomainAPI + Channel + "/api/secure/serviceMenuItem/getAll";
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            // dispatch.serviceMenu.changeIdMenuArray(payload.id)
            _this.setState({ allMenuItem: result.data.list });
            _this.setState({
              listMenu: result.data.list,
              position: result.data.maxPosition,
              total: result.data.total,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getAllMenuItemFeature(payload = {}, rootState) {
      const _this = this;
      // if(!payload.id || (payload.id && !payload.id.length)) payload.id = rootState.serviceMenu.idMenuArray;
      if (payload.id && !payload.id.length) {
        dispatch.serviceMenu.changeIdMenuArray([]);
        _this.setState({ listMenuFeatured: [], position: 0, totalFeatured: 0 });
        return {
          code: 1,
          data: {
            list: [],
            total: 0,
            maxPosition: 0,
          },
        };
      }
      let url = DomainAPI + Channel + "/api/secure/serviceMenuItem/getAll";
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          filter: [{ featured: 1 }],
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            // dispatch.serviceMenu.changeIdMenuArray(payload.id)
            _this.setState({
              listMenuFeatured: result.data.list,
              position: result.data.maxPosition,
              totalFeatured: result.data.total,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    addMenuItem(payload, rootState) {
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let url = DomainAPI + Channel + "/api/secure/serviceMenuItem/addMenuItem";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          serviceCode: serviceCode,
          data: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          dispatch.serviceSetting.getServiceSetting(); // Cập nhât lại list service setting
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    deleteMenuItem(payload, rootState) {
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let url =
        DomainAPI + Channel + "/api/secure/serviceMenuItem/deleteMenuItem";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          serviceCode: serviceCode,
          data: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    changeFeatured(payload = {}, rootState) {
      if (!payload.serviceCode)
        payload.serviceCode = rootState.service.adminService
          ? rootState.service.adminService.no
          : null || null;
      return fetch(
        DomainAPI + Channel + "/api/secure/serviceMenuItem/changeFeatured",
        {
          method: "POST",
          headers: getHeader(true, rootState.user.token),
          body: JSON.stringify({
            itemCode: payload.itemCode,
            serviceCode: payload.serviceCode,
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);

          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },

    searchMenuItem(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {

      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceMenuItem/searchMenuItem";
      return fetch(url, {
        method: "GET",
        headers: getHeader(true, rootState.user.token),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ allMenuItem: res.data });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
  }),
};

export default serviceMenuItem;
